// extracted by mini-css-extract-plugin
module.exports = {"tabItem":"Tab_tabItem__2wHql","tab":"Tab_tab__2s_A1","disabled":"Tab_disabled__1y-xu","highlight":"Tab_highlight__23rpN"};